export default __webpack_public_path__ + "532346745534ceb5216cc3404d89c3c7.webp";